module.exports = __webpack_public_path__ + "static/media/471GriffinStNW_2018-06-05_27.42f9c0ed.jpg";